import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=283810d0&scoped=true&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=283810d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283810d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('283810d0')) {
      api.createRecord('283810d0', component.options)
    } else {
      api.reload('283810d0', component.options)
    }
    module.hot.accept("./ProductCard.vue?vue&type=template&id=283810d0&scoped=true&", function () {
      api.rerender('283810d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/cards/ProductCard.vue"
export default component.exports